import { useAuthSession as useNsiAuthSession } from '@nsi-advisory-services/auth-react';
import { useMe } from '../hooks/useQueries';
import { getImpersonatedUserId } from './impersonation';

// The session fields the app reads, from the shared nsi-auth session. While an admin views the app
// as someone else, the user fields are that person's; signing in and out stay the admin's own.
const useAuthSession = () => {
  const { status, user, signIn, signOut } = useNsiAuthSession();
  const isSignedIn = status === 'signed-in';
  const impersonating = Boolean(getImpersonatedUserId());
  const { data: me } = useMe({ enabled: isSignedIn && impersonating });
  const current = impersonating ? me?.user || null : user;

  return {
    isSignedIn,
    isLoading: status === 'loading',
    userId: current?.oid || null,
    email: current?.email || null,
    displayName: current?.name || current?.email || null,
    signIn,
    signOut,
  };
};

export default useAuthSession;
